module.exports = __webpack_public_path__ + "img/image (2).3112f477.png";